// @flow
import type { Request } from '../../../index';


export type PaymentOrdersParams = {
  customer_id: number,
}

export type PaymentOrder = {
  id: number,
  number: string,
  amount: ?string,
  period_year: ?number,
  period_month: ?number,
  expires_at: ?string,
}

export type PaymentOrdersResult = {
  [key: string]: PaymentOrder,
}

export const GET_PAYMENT_ORDERS: Request<
  PaymentOrdersParams,
  PaymentOrdersResult
> = [
  'cafeteria/customer/payment_orders',
  'get',
  ['data', 'data'],
];
